<template>
  <div class="mypack_vis_wrap renew">
    <div class="mypack_vis_inner">
      <div class="mypack_vis_inner_box">
        <p class="vis_disc">나를 위한 나의 선택</p>
        <p class="logo_img"><img src="/static/images/main_vis_logo.png" alt="" /></p>
        <p class="small_text">
          <span>뉴트리라이트가 제안하는</span>
          <span>나만의 라이프 스타일 맞춤 영양 서비스</span>
        </p>
        <div class="top_action-area">
          <a @click="$router.push('/mypacks')">마이팩 관리</a>
          <a @click="toGuidePage">마이팩 가이드</a>
          <div>
            <button @click="onCompositionClick">
              <i></i><span>직접 <strong>제품 선택하기</strong></span>
            </button>
            <button @click="$router.push('/survey')">
              <i></i><span>건강 설문 후 <strong>제품 추천받기</strong></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeHero",
  components: {},
  props: {},
  data() {
    return {
      guideLink: process.env.MYPACK_GUIDE_URL,
    };
  },
  mounted() {},
  methods: {
    async onCompositionClick() {
      this.$emit("click-composition");
    },
    toGuidePage() {
      window.location.href = this.guideLink;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/home/hero/HomeHero.vue